import styled from 'styled-components';

export const SectionContainer = styled.div`
  gap: 8px;
  display: flex;
  padding: 20px;
  flex-direction: column;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
`;

export const ButtonContainer = styled.div`
  gap: 8px;
  display: flex;
  padding: 20px 20px 0;
  flex-direction: column;
  margin-bottom: -12px;
`;

export const SectionHeader = styled.div`
  gap: 10px;
  min-height: 32px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  align-self: stretch;
  justify-content: center;
  background: ${({ theme }) => theme.tint.primary.subtle};
  margin: 4px 0;

  p {
    margin: 0;
    padding: 0;
    font-size: 20px;
    color: ${({ theme }) => theme.palette.primary.main};
    font-weight: 400;
    text-align: center;
    font-style: normal;
  }
`;

export const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
`;
